module.exports = __webpack_public_path__ + "static/media/fort-collins-desktop.723cb9d3.webp";